import React from 'react';

function SingleQuerySkeleton() {
    return (
        <div className="space-y-4 p-4 animate-pulse mb-4">
            <div className="h-3 w-24 bg-bgGray rounded" />
            <div className="space-y-2">
                <div className="h-3 bg-bgGray rounded w-full" />
                <div className="h-3 bg-bgGray rounded w-5/6" />
                <div className="h-3 bg-bgGray rounded w-4/6" />
            </div>
            <div className="mt-4 max-w-48 bg-bgGray rounded-md h-14 py-8"></div>
        </div>
    );
}

export default function QuerySkeleton() {
    return (
        <div className="space-y-6">
            {[...Array(3)].map((_, index) => (
                <SingleQuerySkeleton key={index} />
            ))}
        </div>
    );
}
